import axios from 'axios';
import { recordApiError } from '../utils/errorCollector';

// Create axios instance
const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '/api',
    withCredentials: true, // Required for sending cookies (session)
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to inject mock auth header
api.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (user && user.email) {
        config.headers['x-mock-user-email'] = user.email;
    }
    return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Server errors and network failures are remembered for bug reports.
        if (!error.response || error.response.status >= 500) {
            recordApiError(error.config?.method, error.config?.url, error.response?.status);
        }
        // Handle session expiry or auth errors here
        if (error.response?.status === 401) {
            // e.g., redirect to login
            console.warn('Unauthorized access');
        }
        // Tenant plan expired — the whole workspace is locked, show a dedicated page
        if (error.response?.status === 402 && error.response.data?.code === 'PLAN_EXPIRED') {
            if (window.location.pathname !== '/plan-expired') {
                window.location.href = '/plan-expired';
            }
        }
        // Module disabled for this tenant — give callers a friendly message to surface
        if (error.response?.status === 403 && error.response.data?.code === 'MODULE_DISABLED') {
            error.friendlyMessage = `The ${error.response.data.module} module is not enabled for your organisation.`;
        }
        return Promise.reject(error);
    }
);

export default api;
